import { type SVGProps } from "react";

export const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}>
    <mask
      id="a"
      width={22}
      height={22}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}>
      <path fill="#fff" d="M1 1h22v22H1V1Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#1B89F6"
        fillRule="evenodd"
        d="M1 12.061C1 17.531 4.972 22.078 10.167 23v-7.945h-2.75V12h2.75V9.555c0-2.75 1.772-4.277 4.278-4.277.794 0 1.65.122 2.444.244v2.811h-1.406c-1.344 0-1.65.672-1.65 1.528V12h2.934l-.489 3.055h-2.445V23C19.028 22.078 23 17.531 23 12.061 23 5.978 18.05 1 12 1S1 5.978 1 12.061Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
